import React, { useEffect, useRef } from 'react';
import { useEquipmentPage } from '../context/EquipmentPageContext';
import { documentUrl, formatDate } from '../equipmentData';

export default function EquipmentDetails() {
  const { selectedEquipment: item, setSelectedEquipment } = useEquipmentPage();
  const dialog = useRef(null);
  useEffect(() => {
    if (item) dialog.current?.showModal();
    else dialog.current?.close();
  }, [item]);
  return <dialog ref={dialog} onCancel={() => setSelectedEquipment(null)} onClick={event => { if (event.target === dialog.current) setSelectedEquipment(null); }}
    aria-label="Equipment details" className="w-full max-w-2xl rounded-2xl border border-slate-200 p-6 text-slate-800 shadow-xl backdrop:bg-slate-900/30">
    {item && <>
      <div className="flex items-start justify-between gap-4 mb-5">
        <div><h2 className="text-lg font-bold">{item.name}</h2><p className="text-xs text-slate-400">#{item.assetId}</p></div>
        <button type="button" aria-label="Close equipment details" onClick={() => setSelectedEquipment(null)} className="rounded-lg border border-slate-200 px-3 py-1 text-sm">Close</button>
      </div>
      <dl className="grid grid-cols-2 gap-4 text-sm">
        {[
          ['Category', item.category], ['Location', [item.location, item.specificArea].filter(Boolean).join(' / ')],
          ['Status', item.decommissioned ? 'Decommissioned' : item.operationalStatus], ['Condition', item.condition], ['Risk level', item.riskLevel],
          ['Brand / Model', [item.brand, item.model].filter(Boolean).join(' / ')], ['Serial number', item.serialNumber], ['Assigned to', item.assignedTo?.fullName],
          ['Next maintenance', item.requiresRoutineMaintenance ? formatDate(item.nextMaintenanceDate) : 'Not required'],
          ['PAT result', item.requiresPat ? item.lastTestResult || 'Not recorded' : 'Not required'], ['Next PAT due', item.requiresPat ? formatDate(item.nextPatDue) : 'Not required'],
          ['Sensor', item.sensorInstalled ? [item.sensorId, item.connectionStatus].filter(Boolean).join(' / ') || 'Not recorded' : 'Not installed'],
          ['Warranty expiry', item.warrantyActive ? formatDate(item.warrantyExpiryDate) : 'No warranty'], ['Registered', formatDate(item.createdAt)], ['Notes', item.notes],
        ].map(([name, value]) => <div key={name}><dt className="text-xs font-semibold text-slate-400">{name}</dt><dd className="mt-1 break-words">{value || '—'}</dd></div>)}
      </dl>
      {documentUrl(item.documentUrl) && <a href={documentUrl(item.documentUrl)} target="_blank" rel="noreferrer" className="mt-5 inline-block text-sm font-semibold text-blue-600">{item.documentName || 'Open equipment document'}</a>}
    </>}
  </dialog>;
}
